import { json, MetadataRow } from "../../global";
import { GenericMetaNode } from "../metadata/GenericMetaNode";
import { PNodeListAbstract } from "./PNodeListAbstract";

// bei einem PNodeListMeta werden die Daten bisher nicht im node gespeichert, weil es
// sich stets um Tabellen aus dem metadata handelt, und die dortigen FK-Relationen
// für die PNodeListMeta verantwortlich sind, und bisher nur Haupttabellen im Scene sowie
// Backref für PNodeListMeta verwendet werden.
// Für die Umsetzung von 1-n Relationen (CSV-Listen) würde eine andere
// PNodeListMeta-Implementierung mit Speicherung der Daten im Node notwendig.
export class PNodeListMeta<N extends GenericMetaNode> extends PNodeListAbstract<N> {
  rows: MetadataRow[];
  metaTable: json;
  canModifyList: boolean;

  constructor(args) {
    super({
      ...args,
    });
    this.canModifyList = args.canModifyList ?? true;
    if (this.rows == null) {
      this.rows = APP.metadata[this.name];
    }
    if (this.metaTable == null) {
      this.metaTable = APP.richMetadata.getMetaTable(this.name);
    }
    if (this.NodeClass == null) {
      this.NodeClass = APP.sceneNode.getNodeClassForMetaTable(this.metaTable) as any;
    }
  }

  fromMetadataRow(metadataRow: MetadataRow): this {
    return this;
    // throw new Error('not intended');
  }

  createNode(row: MetadataRow = { id: undefined }): N {
    return APP.sceneNode.getMetaNodeLazy(row, this.metaTable) as N;
  }

  get(): N[] {
    return this.rows.map((row) => this.createNode(row));
  }

  set(value: N[]): N[] {
    throw new Error("not intended");
  }

  add(value: N) {
    // add darf hier nur transient sein und noch nicht speichern
    // - das row-Objekt ist noch gar nicht mit sinnvollen
    // Werten gefüllt. speichern muss eine explizite User-Aktion sein (speichern-Button)
    // rows kann sein: eine konkrete Tabelle, oder eine Adjazenzliste. In beiden Fällen
    // müssen die Daten in der MetaTable-Data abgelegt werden..
    const rows = APP.metadata[this.metaTable["name"]];
    rows.push(value.meta);
  }

  remove(value: N) {
    // remove sollte hier nur transient sein und vom UI-Button sollte explizit das Remove auf dem Server ausgeführt werden.
    const rows = APP.metadata[this.metaTable["name"]];
    const i = rows.findIndex((n) => n === value.meta);
    if (i >= 0) {
      rows.splice(i, 1);
    }
    value.onRemove();
  }
}
